import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

/** Accessible segmented control (radio group semantics). */
export function Segmented<T extends string | number>({
  value, onChange, options, label, size = 'md', className,
}: {
  value: T;
  onChange: (v: T) => void;
  options: { value: T; label: ReactNode; title?: string; disabled?: boolean }[];
  label: string;
  size?: 'sm' | 'md';
  className?: string;
}) {
  return (
    <div role="radiogroup" aria-label={label} data-segmented="" className={cn('inline-flex rounded-[var(--radius-ctl)] border border-line-strong bg-surface p-0.5', className)}>
      {options.map((o) => {
        const active = o.value === value;
        return (
          <button
            key={String(o.value)}
            type="button"
            role="radio"
            aria-checked={active}
            title={o.title}
            disabled={o.disabled}
            onClick={() => onChange(o.value)}
            className={cn(
              'inline-flex items-center gap-1 rounded-[3px] font-medium transition-colors disabled:cursor-not-allowed disabled:opacity-50',
              size === 'sm' ? 'h-7 px-2 text-xs' : 'h-8 px-3 text-sm',
              active ? 'bg-ink text-bg' : 'text-ink-2 hover:bg-surface-3 hover:text-ink',
            )}
          >
            {o.label}
          </button>
        );
      })}
    </div>
  );
}
